import React from 'react';
import { CtaButton } from './CtaButton';
import { useStickyBar } from '../hooks/useStickyBar';
import { siteConfig } from '../data/siteConfig';
export function StickyBuyBar() {
  const visible = useStickyBar('hero', 'oferta');
  return <div className={`fixed inset-x-0 bottom-0 z-[9999] flex items-center justify-between gap-3.5 bg-forest-dark/95 px-4 pb-[calc(12px+env(safe-area-inset-bottom,0px))] pt-3 backdrop-blur transition-transform duration-300 ease-out md:hidden ${visible ? 'translate-y-0' : 'translate-y-[110%]'}`} aria-hidden={!visible} data-id="element-289" data-mp="3ch26oei8p4b4">
      <div className="font-display text-xl font-extrabold leading-tight text-white" data-id="element-290" data-mp="3ve3ioja7o4ok">
        {siteConfig.price}
        <small className="block text-xs font-medium text-forest-soft" data-id="element-291" data-mp="3qez6rkvwjsuj">
          Pago único · Garantía {siteConfig.guaranteeDays} días
        </small>
      </div>
      <CtaButton size="sm" data-id="element-292" data-mp="2125gv2e8eb2p">Quiero el kit</CtaButton>
    </div>;
}